import React from 'react';
import { PosWheel, PosWheelColumn } from '../../../../components/PosWheel/PosWheel';

export type PosWheelTimePickerProps = {
  value: string;
  onChange: (next: string) => void;
  disabled?: boolean;
};

const HOURS = Array.from({ length: 24 }, (_, i) => String(i).padStart(2, '0'));
const MINUTES = Array.from({ length: 60 }, (_, i) => String(i).padStart(2, '0'));

// Summary: Two scroll-snap wheels (hours 00-23, minutes 00-59) returning 'HH:MM'; shares PosWheel.
export const PosWheelTimePicker: React.FC<PosWheelTimePickerProps> = ({ value, onChange, disabled }) => {
  const [hour, minute] = value.split(':');

  return (
    <PosWheel dir="ltr">
      <PosWheelColumn
        disabled={disabled}
        items={HOURS.map((h) => ({ key: `h-${h}`, label: h, selected: h === hour, testid: `time-picker-hour-${h}`, onClick: () => onChange(`${h}:${minute}`) }))}
      />
      <PosWheelColumn
        disabled={disabled}
        items={MINUTES.map((m) => ({ key: `m-${m}`, label: m, selected: m === minute, testid: `time-picker-minute-${m}`, onClick: () => onChange(`${hour}:${m}`) }))}
      />
    </PosWheel>
  );
};
